import cn from "classnames";
import { ShipmentType, StatusProps } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";
import styles from "./Status.module.scss";

import { CardHeaderStatus } from "../../Card";

type StatusPropsType = StatusProps<CardHeaderStatus> & {
  shipmentType: ValueOf<typeof ShipmentType>;
  dataTestId?: string;
};

export const Status: RFC<StatusPropsType> = ({
  className,
  style,
  status,
  children,
  shipmentType,
  dataTestId,
  ...props
}) => {
  if (!status) return null;

  const classes = cn(styles.status, className);

  return (
    <div className={classes} style={style} data-test-id={dataTestId} {...props}>
      {children}
    </div>
  );
};

Status.displayName = Status.name;
